import {Color, Size} from '../types'
import {getColorVariant, getSizeVariant} from '../utils'

export const getSize = (size: Size, noPaddings?: boolean): string => {
  const small = `px-0 ${noPaddings ? '' : 'py-8'} text-14 leading-4`
  const medium = `px-0 ${noPaddings ? '' : 'py-12'} text-14 leading-4`
  const big = `px-0 ${noPaddings ? '' : 'py-12'} text-16 leading-6`

  return getSizeVariant(size, {small, medium, big})
}

export const getSvgSize = (size: Size): number => {
  const small = 16
  const medium = 16
  const big = 24

  return getSizeVariant(size, {small, medium, big})
}

export const getDefault = (color: Color): string => {
  const primary = 'text-action-default'
  const secondary = 'text-grey'
  const error = 'text-error'
  const warning = 'text-warning'
  const grey = 'text-secondary'
  const invert = 'text-invert'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getDisabled = (color: Color): string => {
  const primary = 'pointer-events-none text-action-disabled'
  const secondary = 'pointer-events-none text-grey-l40'
  const error = 'pointer-events-none text-grey-l40'
  const warning = 'pointer-events-none text-grey-l40'
  const grey = 'pointer-events-none text-action-disabled'
  const invert = 'pointer-events-none text-grey-d40'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getHover = (color: Color): string => {
  const primary = 'hover:text-action-hover'
  const secondary = 'hover:text-grey-l20'
  const error = 'hover:text-error-l20'
  const warning = 'hover:text-warning-l20'
  const grey = 'hover:text-action-hover'
  const invert = 'hover:text-interactive-d80'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getPressed = (color: Color): string => {
  const primary = 'active:text-action-pressed'
  const secondary = 'active:text-grey-d20'
  const error = 'hover:text-error-d20'
  const warning = 'hover:text-warning-d20'
  const grey = 'active:text-action-pressed'
  const invert = 'active:text-interactive-l80'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}
